import React, { useEffect, useState } from 'react';
import { addCommas, bindClose } from '@payfront/components/Util';
import { Groupper, Icon, Pagination, Placeholder, Table, Toolbar } from 'react-frontier';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import API from '../API';
import { Link, useParams } from 'react-router-dom';

interface WebhookViewProps{
	responseId?: number
}

interface Webhook{
	webhook_id: number,
	live: boolean,	
	webhook_url: string,
	basic_username: string,
	basic_password: string,
	date_created: number,
	response_count: number,
	events: number[],
}
interface WebhookLog{
	response_id: number,
	event_id: number,
	payment_id: number,
	response_status: number,
	date_try: number,
	date_response: number,
	date_created: number,
}

enum ShownModal{
	AUTH = 1,
	DELETE = 2,
}

var WebhookView = ()=>{
	var { t } = useTranslation();
	var params = useParams<{ webhook_id: string }>();
	var [webhook, setWebhook] = useState<Webhook>(null);
	var [logs, setLogs] = useState<WebhookLog[]>(null);
	var [offset, setOffset] = useState<number>(0);
	var [shownModal, setShownModal] = useState<ShownModal>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [logLoadError, setLogLoadError] = useState<string>(null);
	var [loadingLogs, setLoadingLogs] = useState<boolean>(false);
	var webhook_id = params && params.webhook_id && !Number.isNaN(parseInt(params.webhook_id)) ? parseInt(params.webhook_id) : null;

	useEffect(()=>{
		if(!webhook_id) return;
		API.getWebhook(webhook_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setWebhook(res.data);
			getLogs(0);
		}).catch(err=>{
			setLoadError(t('common.unexpected_error', { code: 'LCL-WHVW-1' }))
		});
	}, []);

	var getLogs = (offset: number)=>{
		if(!webhook_id) return;
		setOffset(offset);
		setLogs(null);
		API.getWebhookLog(webhook_id, offset, 20).then(res=>{
			if(res.error) return setLogLoadError(res.message);
			setLogs(res.data);
		}).catch(err=>{
			setLogLoadError(t('common.unexpected_error', { code: 'LCL-WHVWLG-1' }));
		});
	}
	
	return <div className="pf webhook-view-scren" style={{ padding: 15 }}>
		<Groupper title={'Detalles'} width={450}>
			<Toolbar>
				<Toolbar.Dropdown text={t('common.edit')} iconName='pen'>
					<Toolbar.Item text={t('webhooks.auth')} onClick={bindClose(setShownModal, ShownModal.AUTH)} />
					<Toolbar.Item text={t('webhooks.events')} onClick={bindClose(setShownModal, ShownModal.AUTH)} />
					<Toolbar.Item text={t('common.delete')} onClick={bindClose(setShownModal, ShownModal.DELETE)} />
				</Toolbar.Dropdown>
			</Toolbar>
			<Table fitted striped details
			 	className='last'
				data={[
					['ID', <Placeholder value={webhook?.webhook_id} width={30} />],
					['URL', <Placeholder value={webhook?.webhook_url} />],
					['Respuestas', <Placeholder value={webhook?.response_count ? addCommas(webhook?.response_count, false) : null} />],
					['Creación', <Placeholder value={webhook?.date_created ? moment.unix(webhook.date_created).format('YYYY-MM-DD HH:mm') : null} width={50} />],
				]}
			/>
		</Groupper>
		<Groupper title={t('webhooks.subscribed_events')} width={450} style={{ marginTop: 15 }}>
			<Table fitted striped details className='last'>
				{webhook ? (
					webhook.events.length==0 ? (
						<Table.Cell row empty>
							{t('webhooks.no_events')}
						</Table.Cell>
					) : webhook.events.map(a=>(
						<Table.Row
							data={[
								<Icon name='check' color='green' />, 
								t(`webhook_events.event${a}`, { defaultValue: 'webhook_events.event_invalid' })
							]}
						/>
					))
				) : <>
					<Table.Row data={[<Placeholder width={40} random={false} />, <Placeholder width={50} />]} />
					<Table.Row data={[<Placeholder width={40} random={false} />, <Placeholder width={50} />]} />
				</>}
			</Table>
		</Groupper>
		<Table 
			striped
			style={{ maxWidth: 700, margin: 'auto', marginTop: 15 }}
			title={t('webhooks.log')}
			headers={['ID', t('webhooks.event'), t('common.payment'), t('common.status'), t('common.date')]}
			footer={!!webhook && (
				<Table.Cell row colSpan={5}>
					<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Pagination
							page={Math.floor(offset/20)}
							disabled={!webhook || loadingLogs}
							pageCount={Math.ceil(webhook.response_count/20)}
							onPageChange={(page)=>{
								getLogs(page*20);
							}}
						/>
					</div>
				</Table.Cell>
			)}
		>
			{logs ? (
				logs.length>0 ? (
					logs.map(a=>(
						<Table.Row selectable compact
							key={`WHRP-${a.response_id}`}
							as={Link}
							to={`/webhooks/${webhook_id}/response/${a.response_id}`}
							collapsingIndexes={[0, 2, 3, 4]}
							data={[
								a.response_id,
								t(`webhook_events.event${a.event_id}`),
								a.payment_id,
								<div style={{ color: a.response_status==200 ? 'green' : 'brown', fontWeight: 'bold', fontSize: 16 }}>
									<Icon name={a.response_status==200 ? 'check' : 'times'} /> {a.response_status}
								</div>,
								moment.unix(a.date_try || a.date_response || a.date_created).format('YYYY-MM-DD HH:mm'),
							]}
						/>
					))
				) : (
					<Table.Cell empty row>
						{t('webhooks.no_logs')}
					</Table.Cell>
				)
			) : (
				new Array(21).fill('wh').map((a, i)=>(
					<Table.Row
						key={`WKLGPH-${i}`}
						collapsingIndexes={[0, 2, 3, 4]}
						data={[
							<Placeholder width={40} random={false} />,
							<Placeholder width={100} />,
							<Placeholder width={40} />,
							<Placeholder width={60} random={false} />,
							<Placeholder width={100} random={false} />,
						]}
					/>
				))
			)}
		</Table>
	</div>
}

export default WebhookView;